export default __webpack_public_path__ + "static/media/location-unavailable-desktop.b744514d.png";